import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-refresh",
  "use": "icon-icon-refresh-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-refresh\">\n<g id=\"icon-icon-refresh_Group 427323625\">\n<path id=\"icon-icon-refresh_Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 14L3 6L5 6L9 6L9 4L7 4L7 2L9 2L9 4L11 4L11 6L13 6L13 8L5 8L5 14L3 14ZM9 14L9 16L11 16L11 14L15 14L17 14L17 6L15 6L15 12L7 12L7 14L9 14ZM11 16L11 18L13 18L13 16L11 16Z\" fill=\"#A6A6A6\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol